module.exports = require("os");


//////////////////
// WEBPACK FOOTER
// external "os"
// module id = 56
// module chunks = 0